/**
 * PopViewer Component
 *
 * Renders POP markdown content in read-only mode.
 * Story 6-5
 */

import { marked } from 'marked';
import { useMemo } from 'react';

interface PopViewerProps {
  content: string;
}

export function PopViewer({ content }: PopViewerProps) {
  const htmlContent = useMemo(() => {
    // Configure marked for safe rendering
    marked.setOptions({
      breaks: true,
      gfm: true,
    });

    return marked(content);
  }, [content]);

  return (
    <div
      data-testid="pop-content"
      className="prose prose-sm max-w-none
        prose-headings:text-gray-900
        prose-p:text-gray-700
        prose-a:text-blue-600
        prose-strong:text-gray-900
        prose-ul:text-gray-700
        prose-ol:text-gray-700
        prose-blockquote:border-blue-500
        prose-code:text-purple-700
        prose-pre:bg-gray-100"
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}
